import "./item_component.css";